import React from 'react'
import PropTypes from 'prop-types'

const DropdownModal = ({
  className = '',
  title = 'Title',
  children = null,
  closeBox = true,
  onCloseBoxClick = null,
  buttons = []
}) => {

  return (
    <div className={`tbModalContent ${className}`}>
      {closeBox &&
        <div className={'tbModalCloseX'} onClick={onCloseBoxClick}></div>
      }
      <h4 className='tbModalTitle'>{title}</h4>
      <div className='tbModalBody'>
        {children}
      </div>
      {buttons.length &&
        <div className='tbModalFooter'>
          {buttons.map(({ text = 'text', onClick, disabled = false, className = '' }, index) => (
            <button
              key={`btn${index}`}
              className={`tbModalButton ${className}`}
              onClick={onClick}
              disabled={disabled}
            >
              {text}
            </button>
          ))}
        </div>
      }
    </div>
  )
}

DropdownModal.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  closeBox: PropTypes.bool,
  onCloseBoxClick: PropTypes.func,
  children: PropTypes.node,
  buttons: PropTypes.arrayOf(PropTypes.shape({
    className: PropTypes.string,
    text: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
  })),
}

export default DropdownModal
